// import React from "react";
// import { Link } from "react-router-dom";

// const OurNetwork = () => {
//  const routes = [
//   {
//     title: "Goa",
//     image: "/images/network/Goa.png",
//     link: "/mumbai-to-goa-cab-service",
//   },
//   {
//     title: "Kolhapur",
//     image: "/images/network/kolhapur.png",
//     link: "/mumbai-to-kolhapur-cab",
//   },
//   {
//     title: "Mumbai Outstations",
//     image: "/images/network/Mumbai-Outstations.png",
//     link: "/mumbai-outstation-cab-service",
//   },
//   {
//     title: "Mumbai - Pune - Mumbai",
//     image: "/images/network/Mumbai--Pune---Mumbai.png",
//     link: "/mumbai-to-pune-cab",
//   },
//   {
//     title: "Nashik",
//     image: "/images/network/Nashik.png",
//     link: "/mumbai-to-nashik-cab",
//   },
//   {
//     title: "Pan India",
//     image: "/images/network/Pan-India.png",
//     link: "/pan-india-cab-service",
//   },
//   {
//     title: "Pune",
//     image: "/images/network/Pune.png",
//     link: "/pune-cab-service",
//   },
//   {
//     title: "Sambhaji Nagar",
//     image: "/images/network/Sambhaji-Nagar.png",
//     link: "/mumbai-to-sambhaji-nagar-cab",
//   },
// ];

//   return (
//     <>
//       {/* Breadcrumb */}
     


// <div
//         className="breadcumb-wrapper"
//         style={{
//           backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//         }}
//       >
//         <div className="container z-index-common">
//           <div className="breadcumb-content">
//             <h1 className="breadcumb-title">Online Network</h1>
//           </div>
//         </div>
//       </div>


//       {/* Network Section */}
//       <section
//         style={{
//           padding: "80px 0",
//           background: "#f8fafc",
//         }}
//       >
//         <div className="container">
//           {/* Heading */}
//           <div className="text-center mb-5">
          

//             {/* <h2
//               style={{
//                 fontWeight: "800",
//                 color: "#0057D9",
//               }}
//             >
//               Popular Cab Routes
//             </h2>

//             <p
//               style={{
//                 maxWidth: "700px",
//                 margin: "10px auto",
//                 color: "#666",
//               }}
//             >
//               Explore our most booked routes with safe, reliable and affordable
//               cab services from Mumbai Airport Cabs Service.
//             </p> */}
//           </div>

//           {/* Cards */}
//           <div className="row">
//             {routes.map((item, index) => (
//               <div className="col-lg-4 col-md-6 mb-4" key={index}>
//                 <Link
//                   to={item.link}
//                   style={{
//                     textDecoration: "none",
//                   }}
//                 >
//                   <div
//                     style={{
//                       borderRadius: "18px",
//                       overflow: "hidden",
//                       background: "#fff",
//                       boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
//                       transition: "0.3s ease",
//                     }}
//                   >
//                     <img
//                       src={item.image}
//                       alt={item.title}
//                       style={{
//                         width: "100%",
//                         height: "240px",
//                         objectFit: "cover",
//                       }}
//                     />

//                     <div
//                       style={{
//                         background:
//                           "linear-gradient(135deg,#1A4160,#1A4160)",
//                         padding: "18px",
//                         textAlign: "center",
//                       }}
//                     >
//                       <h3
//                         style={{
//                           color: "#fff",
//                           fontSize: "22px",
//                           fontWeight: "700",
//                           margin: 0,
//                         }}
//                       >
//                         {item.title}
//                       </h3>
//                     </div>
//                   </div>
//                 </Link>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default OurNetwork;








// import React from "react";
// import {
//   MapContainer,
//   TileLayer,
//   Marker,
//   Popup,
// } from "react-leaflet";
// import MarkerClusterGroup from "react-leaflet-markercluster";
// import L from "leaflet";
// import "leaflet/dist/leaflet.css";
// import "leaflet.markercluster/dist/MarkerCluster.css";
// import "leaflet.markercluster/dist/MarkerCluster.Default.css";

// // INDIA CITY LIST
// // INDIA CITY LIST
// const cities = [
//   { name: "Pune", lat: 18.5204, lng: 73.8567 },
//   { name: "Mumbai", lat: 19.076, lng: 72.8777 },
//   { name: "Delhi", lat: 28.7041, lng: 77.1025 },
//   { name: "Bangalore", lat: 12.9716, lng: 77.5946 },
//   { name: "Ahmedabad", lat: 23.0225, lng: 72.5714 }, // Added here as 5th
//   { name: "Chennai", lat: 13.0827, lng: 80.2707 },
//   { name: "Hyderabad", lat: 17.385, lng: 78.4867 },
//   { name: "Kolkata", lat: 22.5726, lng: 88.3639 },
//   { name: "Vadodara", lat: 22.3072, lng: 73.1812 },
//   { name: "Indore", lat: 22.7196, lng: 75.8577 },
//   { name: "Bhopal", lat: 23.2599, lng: 77.4126 },
//   { name: "Jaipur", lat: 26.9124, lng: 75.7873 },
//   { name: "Nagpur", lat: 21.1458, lng: 79.0882 },
//   { name: "Goa", lat: 15.2993, lng: 74.124 },
//   { name: "Chandigarh", lat: 30.7333, lng: 76.7794 },
//   { name: "Surat", lat: 21.1702, lng: 72.8311 },
//   { name: "Patna", lat: 25.5941, lng: 85.1376 },
// ];

// // CUSTOM MARKER ICON
// const markerIcon = new L.Icon({
//   iconUrl:
//     "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
//   iconSize: [28, 45],
//   iconAnchor: [12, 41],
// });

// export default function NetworkMapPremium() {
//   return (
//     <>
     
//       <header className="cu-hero">
//         <div className="cu-hero__overlay" />
//         <div className="container">
//           <div className="cu-hero__content">
           
//             <div>
//               <h1 className="text-center">Our Premium Network Across India</h1>
// <p className="text-center invisible-text">
//   Travel with Luxury and Comfort
// </p>
//             </div>
//           </div>
//         </div>
//         <div className="cu-hero__curve" />
//       </header>

//       {/* ==== MAIN CONTENT SECTION ==== */}
//       <div
//         style={{
//           display: "flex",
//           maxWidth: "1400px",
//           margin: "40px auto",
//           gap: "30px",
//           padding: "20px",
//         }}
//       >
//         {/* LEFT: MAP */}
//         <div
//           style={{
//             flex: 2,
//             borderRadius: "20px",
//             overflow: "hidden",
//             boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
//             backdropFilter: "blur(6px)",
//           }}
//         >
//           <MapContainer
//             center={[22.9734, 78.6569]}
//             zoom={5}
//             scrollWheelZoom={true}
//             style={{ height: "600px", width: "100%" }}
//           >
//             <TileLayer
//               url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//               attribution="© OpenStreetMap"
//             />

//             {/* MARKER CLUSTERING */}
//             <MarkerClusterGroup>
//               {cities.map((city, i) => (
//                 <Marker
//                   key={i}
//                   position={[city.lat, city.lng]}
//                   icon={markerIcon}
//                 >
//                   <Popup>
//                     <b style={{ fontSize: "16px" }}>{city.name}</b>
//                   </Popup>
//                 </Marker>
//               ))}
//             </MarkerClusterGroup>
//           </MapContainer>
//         </div>

//         {/* RIGHT: CITY LIST */}
//         <div
//           style={{
//             flex: 1,
//             background: "white",
//             padding: "25px",
//             borderRadius: "20px",
//             boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
//             height: "600px",
//             overflowY: "auto",
//           }}
//         >
//           <h3
//             style={{
//               marginBottom: "20px",
//               fontWeight: "700",
//               fontSize: "26px",
//               color: "#0d47a1",
//             }}
//           >
//             Our Service Cities
//           </h3>

//           {/* CITY LIST */}
//           <ul style={{ padding: 0, listStyle: "none" }}>
//             {cities.map((city, index) => (
//               <li
//                 key={index}
//                 style={{
//                   padding: "12px 15px",
//                   marginBottom: "10px",
//                   borderRadius: "12px",
//                   background: "#f5f7fa",
//                   cursor: "pointer",
//                   fontWeight: "500",
//                   fontSize: "18px",
//                   color: "#333",
//                   transition: "0.3s",
//                 }}
//                 onMouseEnter={(e) =>
//                   (e.currentTarget.style.background = "#e3f2fd")
//                 }
//                 onMouseLeave={(e) =>
//                   (e.currentTarget.style.background = "#f5f7fa")
//                 }
//               >
//                 📍 {city.name}
//               </li>
//             ))}
//           </ul>
//         </div>
//       </div>
//     </>
//   );
// }












import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

/* =======================
   CITY DATA
======================= */
const cities = [
  // Maharashtra
  { name: "Mumbai", lat: 19.0760, lng: 72.8777 },
  { name: "Navi Mumbai", lat: 19.0330, lng: 73.0297 },
  { name: "Thane", lat: 19.2183, lng: 72.9781 },
  { name: "Pune", lat: 18.5204, lng: 73.8567 },
  { name: "Nashik", lat: 19.9975, lng: 73.7898 },
  { name: "Aurangabad", lat: 19.8762, lng: 75.3433 },
  { name: "Nagpur", lat: 21.1458, lng: 79.0882 },
  { name: "Kolhapur", lat: 16.7050, lng: 74.2433 },
  { name: "Solapur", lat: 17.6599, lng: 75.9064 },
  { name: "Satara", lat: 17.6805, lng: 74.0183 },
  { name: "Sangli", lat: 16.8524, lng: 74.5815 },
  { name: "Ratnagiri", lat: 16.9902, lng: 73.3120 },
  { name: "Sindhudurg", lat: 16.3492, lng: 73.5594 },
  { name: "Lonavala", lat: 18.7546, lng: 73.4062 },
  { name: "Mahabaleshwar", lat: 17.9307, lng: 73.6477 },
  { name: "Alibaug", lat: 18.6414, lng: 72.8722 },
  { name: "Shirdi", lat: 19.7666, lng: 74.4774 },
  { name: "Jalgaon", lat: 21.0077, lng: 75.5626 },
  { name: "Amravati", lat: 20.9374, lng: 77.7796 },
  { name: "Akola", lat: 20.7096, lng: 77.0082 },

  // Gujarat
  { name: "Ahmedabad", lat: 23.0225, lng: 72.5714 },
  { name: "Surat", lat: 21.1702, lng: 72.8311 },
  { name: "Vadodara", lat: 22.3072, lng: 73.1812 },
  { name: "Rajkot", lat: 22.3039, lng: 70.8022 },
  { name: "Vapi", lat: 20.3710, lng: 72.9043 },

  // Telangana
  { name: "Hyderabad", lat: 17.3850, lng: 78.4867 },
  { name: "Warangal", lat: 17.9689, lng: 79.5941 },

  // Karnataka
  { name: "Bengaluru", lat: 12.9716, lng: 77.5946 },
  { name: "Belagavi", lat: 15.8497, lng: 74.4977 },
  { name: "Hubballi", lat: 15.3647, lng: 75.1240 },

  // Goa
  { name: "Panaji", lat: 15.4909, lng: 73.8278 },
  { name: "Margao", lat: 15.2993, lng: 73.9580 },

  // Madhya Pradesh
  { name: "Indore", lat: 22.7196, lng: 75.8577 },
  { name: "Bhopal", lat: 23.2599, lng: 77.4126 },

  // Chhattisgarh
  { name: "Raipur", lat: 21.2514, lng: 81.6296 },

  // Delhi
  { name: "New Delhi", lat: 28.6139, lng: 77.2090 },
];

/* =======================
   CUSTOM BLUE PIN ICON
======================= */
const bluePin = new L.Icon({
  iconUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
  iconSize: [30, 46],
  iconAnchor: [15, 46],
  popupAnchor: [0, -40],
  shadowSize: [41, 41],
});

/* =======================
   COMPONENT
======================= */
export default function NetworkMapPremium() {
  return (
    <>
      {/* HERO */}
<div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container z-index-common">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Online Network</h1>
          </div>
        </div>
      </div>

      {/* MAIN SECTION */}
      <div
        style={{
          display: "flex",
          maxWidth: "1400px",
          margin: "40px auto",
          gap: "30px",
          padding: "20px",
        }}
      >
        {/* MAP */}
        <div
          style={{
            flex: 2,
            borderRadius: "20px",
            overflow: "hidden",
            boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
          }}
        >
          <MapContainer
            center={[22.9734, 78.6569]}
            zoom={5}
            style={{ height: "600px", width: "100%" }}
            scrollWheelZoom
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution="© OpenStreetMap contributors"
            />

            {/* SINGLE MARKERS (NO CLUSTER) */}
            {cities.map((city, index) => (
              <Marker
                key={index}
                position={[city.lat, city.lng]}
                icon={bluePin}
              >
                <Popup>
                  <strong style={{ fontSize: "15px" }}>
                    {city.name}
                  </strong>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>

        {/* CITY LIST */}
        <div
          style={{
            flex: 1,
            background: "#fff",
            padding: "25px",
            borderRadius: "20px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
            height: "600px",
            overflowY: "auto",
          }}
        >
          <h3
            style={{
              marginBottom: "20px",
              fontWeight: "700",
              fontSize: "26px",
              color: "#0d47a1",
            }}
          >
            Our Service Cities
          </h3>

          <ul style={{ padding: 0, listStyle: "none" }}>
            {cities.map((city, index) => (
              <li
                key={index}
                style={{
                  padding: "12px 15px",
                  marginBottom: "10px",
                  borderRadius: "12px",
                  background: "#D8A33A",
                  color: "white",
                  fontSize: "18px",
                }}
              >
                📍 {city.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}
